import {AccountContactData, AccountContactDataUpsertDTO} from "../models/accountContactData";
import {authFetch} from "../auth/authFetch";

const BASE_URL = "/api/accountContactData";

export async function upsertAccountContactData(
    accountId: number,
    dto: AccountContactDataUpsertDTO
): Promise<AccountContactData> {
    const res = await authFetch(`${BASE_URL}/${accountId}`, {
        method: "PUT",
        headers: {"Content-Type": "application/json"},
        body: JSON.stringify(dto)
    });

    if (!res.ok) {
        throw new Error(await res.text());
    }

    return res.json() as Promise<AccountContactData>;
}

export async function getAccountContactDataById(accountId: number): Promise<AccountContactData | null> {
    return getAccountContactData(`${BASE_URL}/${accountId}`);
}

export async function getSharedAccountContactDataById(requesterId: number, targetId: number): Promise<AccountContactData | null> {
    return getAccountContactData(`${BASE_URL}/${requesterId}/${targetId}`);
}

async function getAccountContactData(url: string): Promise<AccountContactData | null> {
    const res = await authFetch(url, {
        method: "GET",
        headers: {"Accept": "application/json"}
    });

    if (res.status === 404) {
        return null;
    }

    if (!res.ok) {
        throw new Error(await res.text());
    }

    return res.json() as Promise<AccountContactData>;
}
